/* Moments Etched v14.9.2 — audited accessibility behavior remediation */
(() => {
  'use strict';

  /* ARIA radio pattern for the custom order-type chooser: one tab stop plus arrows. */
  function initOrderTypeGroup(group) {
    if (!group || group.dataset.meA11yRadioReady === 'true') return;
    group.dataset.meA11yRadioReady = 'true';
    const radios = Array.from(group.querySelectorAll('[role="radio"]'));
    if (!radios.length) return;

    const sync = () => {
      let selected = radios.find((radio) => radio.getAttribute('aria-checked') === 'true');
      if (!selected) selected = radios[0];
      radios.forEach((radio) => { radio.tabIndex = radio === selected ? 0 : -1; });
    };

    const activate = (radio) => {
      radio.focus();
      radio.click();
      requestAnimationFrame(sync);
    };

    group.addEventListener('keydown', (event) => {
      const current = event.target.closest?.('[role="radio"]');
      if (!current || !radios.includes(current)) return;
      if (!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key)) return;
      event.preventDefault();
      const index = radios.indexOf(current);
      let next = index;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % radios.length;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + radios.length) % radios.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = radios.length - 1;
      activate(radios[next]);
    });

    new MutationObserver(sync).observe(group, { subtree: true, attributes: true, attributeFilter: ['aria-checked','aria-pressed'] });
    sync();
  }

  const init = (root = document) => {
    root.querySelectorAll?.('[data-me-order-type] [role="radiogroup"]').forEach(initOrderTypeGroup);

    /* Dynamic content counts and purchase status are announcements, not just visual text. */
    root.querySelectorAll?.('[data-me-design-count], [data-me-catalog-count], [data-me-finished-status]').forEach((node) => {
      node.setAttribute('role', 'status');
      node.setAttribute('aria-live', 'polite');
      node.setAttribute('aria-atomic', 'true');
    });

    /* Make custom search inputs expose a stable accessible name even if CSS utilities fail. */
    root.querySelectorAll?.('[data-me-design-search]').forEach((input) => {
      if (!input.getAttribute('aria-label') && !input.getAttribute('aria-labelledby')) input.setAttribute('aria-label', 'Search designs in this collection');
    });
    root.querySelectorAll?.('[data-me-catalog-search]').forEach((input) => {
      if (!input.getAttribute('aria-label') && !input.getAttribute('aria-labelledby')) input.setAttribute('aria-label', 'Search this collection');
    });
  };

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));

  /* Any dialog opened after pointer/keyboard interaction must expose a focusable title/close path. */
  document.addEventListener('keydown', (event) => {
    const lightbox = document.querySelector('.me-finished__lightbox:not([hidden])');
    if (!lightbox) return;
    if (event.key === 'Escape') return; // component handles close + focus restoration
    /* Zoom controls already support +, -, 0. Announce that keyboard affordance once focus enters. */
    if (event.key === 'Tab' && !lightbox.dataset.meA11yHelpAnnounced) {
      lightbox.dataset.meA11yHelpAnnounced = 'true';
      const announcer = document.getElementById('me-a11y-announcer');
      if (announcer) announcer.textContent = 'Larger preview. Use plus and minus to zoom, zero to reset, and Escape to close.';
    }
  }, true);
})();
